import { useQuery } from '@tanstack/react-query';

import { useHB } from '@/api/queries/objects';

type HoofdstukHBProps = {
  besluitId?: string;
  hoofdstukId?: string;
};

type HoofdstukHBOptions = {
  staleTime?: number;
  enabled?: boolean;
};

const getOptions = (
  props: HoofdstukHBProps,
  options: HoofdstukHBOptions = { enabled: true }
) => {
  return useHB.getOptions(
    {
      page: 1,
      size: 1,
      filter: [
        {
          field: 'Besluit',
          value: props.besluitId ?? '',
          op: 'eq',
        },
        {
          field: 'Hoofdstuk',
          value: props.hoofdstukId ?? '',
          op: 'eq',
        },
      ],
    },
    {
      enabled: !!props.besluitId && !!props.hoofdstukId && options.enabled,
      select: ({ objects }) => {
        return objects?.[0];
      },
    }
  );
};

/**
 * useQuery to get the HB of a hoofdstuk
 */
const useHoofdstukHB = (
  props: HoofdstukHBProps,
  options: HoofdstukHBOptions = { enabled: true }
) => useQuery(getOptions(props, options));
useHoofdstukHB.getOptions = getOptions;

export { useHoofdstukHB };
